export { PLUGIN_KEY, PLUGIN_PRIORITY, Autofill } from "./autofill.mjs";


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/autofill/index.mjs
// module id = 1238
// module chunks = 1